import APIService from './apiservice';
import cookie from 'js-cookie';
import { API_CLIENT_ID, API_CLIENT_SECRET } from '../constants';

const grant_type = 'password';
const user_info = 'userInfo';
const scope = '*';


class AuthService{
	
  async login(username, password) {
	  const data = await APIService.doPublicRequest(`api/v1/auth/login`, 'POST', {
              username,
              password,
              grant_type,
              scope,
              client_id: API_CLIENT_ID,
              client_secret: API_CLIENT_SECRET
          });
        
      if (data?.access_token) {
		    APIService.setToken(data.access_token);
        APIService.setTokenExpiresAt(data.expires_in);
        return data;
      }
      
      return null;
      
  }

  async loginAs(data) {
    const response = await APIService.doRequest(`api/v1/login-as`, 'POST', data);
	  return response;
  }

  async logoutAs() {
    const response = await APIService.doRequest(`api/v1/logout-as`, 'POST');
	  return response.data;
  }

  async logout() {
	  try{
		  await APIService.doRequest(`api/v1/logout`, 'POST');
	  } catch (error){
		  
	  } finally {
		  APIService.handleLogout();
	  }
  }
  
  async getCurrentUser(){
	  let userInfo = APIService.getUserInfo();
	  const withAccessToken = APIService.getToken() ? true : false;
	  
	  if(userInfo === null && withAccessToken){
		  userInfo = await APIService.doRequest(`api/v1/auth-user-details`, 'GET');
      console.log('userInfo', userInfo);
		  APIService.setUserInfo(userInfo);
	  }
	  return userInfo;
  }

  async doChangePassword(data){
    const response = await APIService.doRequest(`api/v1/auth/change-password`, 'POST', data);
    APIService.setUserInfo(response.data);
	  return response.data;
  }

  async doForgotPassword(data){
    const response = await APIService.doPublicRequest(`api/v1/auth/forgot-password`, 'POST', data);
	  return response;
  }

  async doResetPassword(data){
    const response = await APIService.doPublicRequest(`api/v1/auth/reset-password`, 'POST', data);
	  return response;
  }
  
  async getCurrentUserModules(){
	  const withAccessToken = APIService.getToken() ? true : false;
	  if(withAccessToken){
		  return await APIService.doRequest(`api/v1/auth-user-modules`, 'GET');		  
	  }
	  return [];
  }

  async getCurrentUserProfile(){
	  const withAccessToken = APIService.getToken() ? true : false;
	  if(withAccessToken){
		  return await APIService.doRequest(`api/v1/auth-user-profile`, 'GET');		  
	  }
	  return [];
  }
  
  withAccessToken() {
	  return APIService.getToken() ? true : false;
  }

  getAccessToken() {
	  return APIService.getToken();
  }

  getUserInfo(){
    const userInfo = cookie.get(user_info);
    if(userInfo){
      return JSON.parse(userInfo);
    }
    return null;
  }

  getIsImpersonating(){
    return APIService.getIsImpersonating();
  }

  getOriginalUserAccessToken() {
	  return APIService.getOriginalUserToken();
  }
  
}

const authService = new AuthService();

export default authService;